import type {
  ISendSupraDocumentsEmailBody,
  ISendSupraDocumentsEmailRequest,
  ISendSupraDocumentsEmailResponse,
} from '@/app-package';
import axios from 'axios';

/**
 * Post request to trigger sending Supra documents via email
 * @param params.documents - Array of documents to send, each with an id and name
 * @returns Promise<void>
 */
const sendSupraDocumentsEmail = async ({
  documents,
}: ISendSupraDocumentsEmailBody): Promise<void> => {
  const config: ISendSupraDocumentsEmailRequest = {
    url: `/supra/email-documents`,
    data: { documents },
    method: 'post',
  };
  await axios.request<ISendSupraDocumentsEmailResponse>(config);
};

export default sendSupraDocumentsEmail;
